export default __webpack_public_path__ + "static/media/videoBgImage.327f8c39.png";